import { isNil } from "lodash";

import { type TableState } from "@features/sales-v4/types";
import { type SalesMetricV2 } from "@north-beam/nb-client-side/metrics-v2";
import { type SalesMetricRow } from "@north-beam/nb-common";
import { type CellContext } from "@tanstack/react-table";

import { getMetricComparison } from "../utils";

import { Tooltip } from "./tooltip";

type Props<TData> = {
  metric: SalesMetricV2;
  cell: CellContext<TData, unknown>;
  value?: string | number;
  tableState: TableState;
};

export const CellAvgTouchpointsPerOrderFormatter = <
  TData extends SalesMetricRow,
>({
  cell,
  metric,
  value,
  tableState,
}: Props<TData>) => {
  const rowData = cell.row.original as SalesMetricRow;
  const { metrics, comparisonMetrics } = rowData;

  return (
    <Tooltip row={cell.row.original} tableState={tableState}>
      <div className="border-r-1 border-x-v2-tertiary text-v2-primary px-4 py-2.5 bg-inherit font-mono text-xs flex items-center justify-end h-full">
        <div
          className={`flex ${
            tableState.showPercentChange ? "flex-col items-end" : "items-center"
          } justify-end gap-1`}
        >
          {!isNil(value) ? value : String(cell.getValue())}
          {getMetricComparison(
            metric,
            metrics,
            comparisonMetrics,
            tableState.showPercentChange,
          )}
        </div>
      </div>
    </Tooltip>
  );
};
